module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title"
  }, [_vm._v("THE “I’S” OF TEXAS INVENTIONS, INVENTORS AND INNOVATORS")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Texas enjoys a worldwide mystique. Travel anywhere in this whole wide world and tell someone you are from any other state in the United States and there will be little reaction. Tell them you are from Texas and an image appears in their head: cowboys, horses, oil fields, high fashion, big business and vast prairies. Hollywood may have enhanced and embellished the image of Texans as being big-thinking, straight-shooting and bull-headed, but the bigger-than-life Texas reputation didn’t come about by chance, and it didn’t happen overnight. The Texas mystique traces its heritage back to real-life pioneers with pluck and courage who transformed a loose-knit people living in an early frontier outpost into a people with a history like no other place in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The “I’s” of Texas are the innovators, inventors and inventions that have made Texas an exciting, progressive and forward-looking place since the 1830s. There have been many of these determined and insightful men and women, and this book selects a few to illustrate how Texas and the world benefited from their lives and talents.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a438f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 81
// module chunks = 0